// fetc-redesign-2026.js — FETC redesign 2026 foundation scaffold
// === 0. 基盤: --fetc-header-total-h ResizeObserver + scroll 透過ヒーロー ===
(function() {
  // ResizeObserver で util-bar + header の合計高さを追跡
  function updateHeaderHeight() {
    var utilBar = document.querySelector('.fetc-util-bar, .section-announcement-bar');
    var header = document.querySelector('.pageheader, #pageheader');
    var utilH = utilBar ? utilBar.offsetHeight : 0;
    var headerH = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--fetc-header-total-h', (utilH + headerH) + 'px');
  }
  updateHeaderHeight();
  if (window.ResizeObserver) {
    var targets = ['.fetc-util-bar', '.section-announcement-bar', '.pageheader'].map(function(sel) {
      return document.querySelector(sel);
    }).filter(Boolean);
    var ro = new ResizeObserver(updateHeaderHeight);
    targets.forEach(function(t) { ro.observe(t); });
  }

  // scroll 透過ヒーロー（60px 閾値）
  if (document.body.classList.contains('hero-transparent-ready')) {
    document.body.classList.add('hero-transparent');
    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        document.body.classList.remove('hero-transparent');
      } else {
        document.body.classList.add('hero-transparent');
      }
    }, { passive: true });
  }

  // ESC 一括クローズ（mega / cart / mobile / search / sub-dropdown / locale）
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.sub-dropdown.is-open, .locale-listbox.is-open').forEach(function(el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[aria-expanded="true"]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('mobile-nav-open');
    document.body.style.overflow = '';
  });
})();
/* ============================================================
   CART: Gift Note Collapse Toggle
   ============================================================ */
(function () {
  'use strict';

  function initCartExtras() {
    var toggles = document.querySelectorAll('.fetc-cart-extras__toggle');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var fieldId = toggle.getAttribute('aria-controls');
        if (!fieldId) { return; }
        var field = document.getElementById(fieldId);
        if (!field) { return; }
        if (expanded) {
          field.classList.remove('is-open');
        } else {
          field.classList.add('is-open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartExtras);
  } else {
    initCartExtras();
  }
})();
// === 5. SUB BAR: ドロップダウン fixed 座標計算 ===
window.FETCSubBar = (function() {
  function closeAll() {
    document.querySelectorAll('.sub-dropdown.is-open').forEach(function(dd) {
      dd.classList.remove('is-open');
      dd.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.sub-item button[aria-expanded="true"]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }
  function toggleDrop(btnId, ddId, anchorId) {
    var btn = document.getElementById(btnId);
    var dd = document.getElementById(ddId);
    var anchor = document.getElementById(anchorId);
    if (!btn || !dd) return;
    var wasOpen = dd.classList.contains('is-open');
    closeAll();
    if (!wasOpen) {
      if (dd.parentElement !== document.body) {
        document.body.appendChild(dd);
      }
      var rect = anchor.getBoundingClientRect();
      dd.style.top  = (rect.bottom + 1) + 'px';
      dd.style.left = rect.left + 'px';
      dd.classList.add('is-open');
      dd.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    }
  }
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.sub-item') && !e.target.closest('.sub-dropdown')) {
      closeAll();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAll();
  });
  return { toggleDrop: toggleDrop, closeAll: closeAll };
})();

/* === PRODUCT-TEA T-6: Volume Pricing JS === */
/* FETC CUSTOM: Volume Pricing — qty stepper integration (redesign-2026) */
(function () {
  'use strict';

  function initVolumePricing() {
    var volumeEl = document.querySelector('.fetc-volume');
    if (!volumeEl) return;

    var tiers = Array.prototype.slice.call(volumeEl.querySelectorAll('.fetc-volume__tier'));
    var saveEl = document.getElementById('fetc-volume-save');
    var priceEl = document.querySelector('.fetc-price__current .money, .fetc-price__current, .price__price .theme-money');
    var atcBtn = document.querySelector('.product-form__submit');
    var qtyInput = document.querySelector('.quantity__input, [name="quantity"]');

    if (!priceEl || !atcBtn || !qtyInput) return;

    /* FETC CUSTOM CR-35: 価格は Liquid data 属性（market 通貨の最小単位）から取得。
       textContent パース + ¥ 固定 formatYen は非 JPY market で誤表示のため廃止 */
    var unitCents = parseInt(volumeEl.getAttribute('data-unit-cents'), 10) || 0;
    var moneyFmt = volumeEl.getAttribute('data-money-format') || '';

    function tierRate(q) {
      if (q >= 6) return 0.10;
      if (q >= 3) return 0.05;
      return 0;
    }

    function activeTierMin(q) {
      if (q >= 6) return 6;
      if (q >= 3) return 3;
      return 0;
    }

    function formatMoney(cents) {
      var dec = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var noDec = Math.round(cents / 100).toLocaleString('en-US');
      if (moneyFmt.indexOf('{{') !== -1) {
        return moneyFmt
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dec)
          .replace(/\{\{\s*amount\s*\}\}/g, dec);
      }
      return '\u00A5' + noDec;
    }

    function applyPricing() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      var rate = tierRate(qty);
      var unit = Math.round(unitCents * (1 - rate));
      var total = unit * qty;
      var minActive = activeTierMin(qty);

      /* Tier button active state */
      tiers.forEach(function (tier) {
        var min = parseInt(tier.getAttribute('data-min'), 10);
        tier.classList.toggle('is-active', min === minActive);
      });

      /* Save note */
      if (saveEl) {
        if (rate > 0 && unitCents > 0) {
          saveEl.textContent = formatMoney(unitCents * qty - total) + ' (' + Math.round(rate * 100) + '% off)';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      /* FETC CUSTOM CR-31/CR-35: ATC ボタンに動的価格（mock: Add to cart — ¥X・qty>=2 は合計額）。
         CR-35 で全通貨対応（unitCents + shop.money_format） */
      if (atcBtn && !atcBtn.disabled && unitCents > 0) {
        var atcLabel = atcBtn.getAttribute('data-add-to-cart-text') || 'Add to cart';
        atcBtn.textContent = atcLabel + ' \u2014 ' + formatMoney(qty > 1 ? total : unit);
      }
    }

    /* Tier button click → set qty */
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        var min = parseInt(tier.getAttribute('data-min'), 10);
        qtyInput.value = min;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        applyPricing();
      });
    });

    /* Qty input change */
    qtyInput.addEventListener('change', applyPricing);
    qtyInput.addEventListener('input', applyPricing);

    applyPricing();
  }

  document.addEventListener('DOMContentLoaded', initVolumePricing);
  document.addEventListener('variant:changed', initVolumePricing); /* Symmetry バリアント切替イベント */
})();
/* END FETC CUSTOM */

/* === PRODUCT-TEA T-13: Sticky ATC JS === */
/* FETC CUSTOM: Sticky ATC scroll visibility (redesign-2026) */
(function () {
  'use strict';

  function initStickyAtc() {
    var bar = document.querySelector('.sticky-atc');
    if (!bar) return;

    /* Show bar after user scrolls past the main ATC button */
    var atcBtn = document.querySelector('.product-form__submit');
    if (!atcBtn) return;

    function onScroll() {
      var rect = atcBtn.getBoundingClientRect();
      /* ATC button is above viewport → show sticky bar */
      if (rect.bottom < 0) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', initStickyAtc);
})();
/* END FETC CUSTOM */

/* === PRODUCT-TEA T-10: Tab exclusive open (accordion → tab UX) === */
/* FETC CUSTOM: Accordion exclusive open — one tab at a time (redesign-2026) */
(function () {
  'use strict';

  function initTabs() {
    var accordion = document.querySelector('.template-product .product-info-accordion');
    if (!accordion) return;

    var disclosures = Array.prototype.slice.call(accordion.querySelectorAll('details.disclosure'));

    disclosures.forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (detail.open) {
          disclosures.forEach(function (other) {
            if (other !== detail && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTabs);
})();
/* END FETC CUSTOM */

// === SEARCH S-2: TYPE FILTER TABS ===
/* FETC CUSTOM: S-2 Type Filter Tabs JS — aria-labelledby 突合トグル — redesign-2026 */
// S-2. Type Filter Tabs — client-side section toggle + deep-link ?tab=
(function () {
  'use strict';
  var tabs = document.querySelectorAll('.search-tabs__tab');
  if (!tabs.length) return;
  var showingEl = document.querySelector('.search-sort-row .text-mut');
  var originalShowingText = showingEl ? showingEl.textContent : '';
  var paginationRow = document.querySelector('.fetc-pagination-wrap[data-ajax-container]');
  var originalPaginationDisplay = paginationRow ? paginationRow.style.display : '';
  var resultCardSelector = [
    '.fetc-tea-card',
    '.fetc-ware-card',
    '.fetc-merch-card',
    '.product-block',
    'product-block',
    '.fetc-article-card',
    '.fetc-page-result'
  ].join(', ');

  var sectionMap = {
    all:     ['search-sec-teas', 'search-sec-ware', 'search-sec-reading', 'search-sec-merch'],
    teas:    ['search-sec-teas'],
    teaware: ['search-sec-ware'],
    reading: ['search-sec-reading'],
    merch:   ['search-sec-merch']
  };

  function arrayContains(items, value) {
    var i;
    for (i = 0; i < items.length; i += 1) {
      if (items[i] === value) return true;
    }
    return false;
  }

  function getQueryParam(name) {
    var query = window.location.search ? window.location.search.substring(1).split('&') : [];
    var i;
    var pair;
    for (i = 0; i < query.length; i += 1) {
      pair = query[i].split('=');
      if (decodeURIComponent(pair[0].replace(/\+/g, ' ')) === name) {
        return decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
      }
    }
    return '';
  }

  function updateSearchMeta(key) {
    var panel;
    var count;

    if (showingEl) {
      if (key === 'all') {
        showingEl.textContent = originalShowingText;
      } else {
        panel = document.getElementById('search-panel-' + key);
        count = panel ? panel.querySelectorAll(resultCardSelector).length : 0;
        showingEl.textContent = 'Showing 1\u2013' + count + ' of ' + count;
      }
    }

    if (paginationRow) {
      paginationRow.style.display = key === 'all' ? originalPaginationDisplay : 'none';
    }
  }

  function activateTab(key) {
    var i;
    var sections;
    var active;
    var visible;
    var sec;
    var headId;

    for (i = 0; i < tabs.length; i += 1) {
      tabs[i].setAttribute('aria-selected', 'false');
    }
    active = document.querySelector('.search-tabs__tab[data-tab="' + key + '"]');
    if (active) active.setAttribute('aria-selected', 'true');

    visible = sectionMap[key] || sectionMap.all;
    sections = document.querySelectorAll('.search-section');
    for (i = 0; i < sections.length; i += 1) {
      sec = sections[i];
      headId = sec.getAttribute('aria-labelledby');
      sec.style.display = (key === 'all' || arrayContains(visible, headId)) ? '' : 'none';
    }
    updateSearchMeta(key);
  }

  for (var i = 0; i < tabs.length; i += 1) {
    tabs[i].addEventListener('click', function () {
      activateTab(this.getAttribute('data-tab'));
    });
  }

  // Deep-link: ?tab=teas 等で初期タブを選択
  (function () {
    var tabParam = getQueryParam('tab').toLowerCase();
    if (tabParam && sectionMap[tabParam]) {
      activateTab(tabParam);
    }
  })();
}());
/* END FETC CUSTOM */

/* === APPAREL A-3: Color chip init === */
/* FETC CUSTOM: Apparel — Color chip init (redesign-2026) */
(function () {
  var colorBlock = document.getElementById('pdp-color-block');
  var colorsEl = document.getElementById('pdp-colors');
  var colorCurrent = document.getElementById('pdp-color-current');
  if (!colorBlock || !colorsEl) return;

  var productData = window.__fetcProductData;
  if (!productData) return;

  var colorOption = null;
  var colorOptionIdx = -1;
  (productData.options || []).forEach(function (opt, idx) {
    if (opt.toLowerCase() === 'color') {
      colorOption = opt;
      colorOptionIdx = idx;
    }
  });
  if (colorOptionIdx < 0) { colorBlock.hidden = true; return; }

  var colorValues = [];
  (productData.variants || []).forEach(function (v) {
    var c = v['option' + (colorOptionIdx + 1)];
    if (c && colorValues.indexOf(c) < 0) colorValues.push(c);
  });

  var currentColor = colorValues[0] || null;
  if (colorCurrent && currentColor) colorCurrent.textContent = currentColor;

  colorValues.forEach(function (c) {
    var b = document.createElement('button');
    var mod = c.toLowerCase().indexOf('black') > -1 ? 'pdp-color--black' : 'pdp-color--white';
    b.className = 'pdp-color ' + mod + (c === currentColor ? ' pdp-color--selected' : '');
    b.type = 'button';
    b.setAttribute('aria-label', c);
    b.setAttribute('aria-pressed', c === currentColor ? 'true' : 'false');
    b.addEventListener('click', function () {
      currentColor = c;
      if (colorCurrent) colorCurrent.textContent = c;
      colorsEl.querySelectorAll('.pdp-color').forEach(function (x) {
        x.classList.remove('pdp-color--selected');
        x.setAttribute('aria-pressed', 'false');
      });
      b.classList.add('pdp-color--selected');
      b.setAttribute('aria-pressed', 'true');
      var nativePicker = document.querySelector('.variant-picker [data-option-index="' + colorOptionIdx + '"]');
      if (nativePicker) {
        nativePicker.value = c;
        nativePicker.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof window.fetcApparelRefreshSizes === 'function') {
        window.fetcApparelRefreshSizes(c);
      }
    });
    colorsEl.appendChild(b);
  });
})();
/* END FETC CUSTOM */

/* === APPAREL A-4: Size swatch init === */
/* FETC CUSTOM: Apparel — Size swatch init + refreshSizes + syncBuy (redesign-2026) */
(function () {
  var sizeBlock = document.getElementById('pdp-size-block');
  var sizesEl = document.getElementById('pdp-sizes');
  var sizeCurrent = document.getElementById('pdp-size-current');
  if (!sizeBlock || !sizesEl) return;

  var productData = window.__fetcProductData;
  if (!productData) return;

  var sizeOptionIdx = -1;
  var colorOptionIdx = -1;
  (productData.options || []).forEach(function (opt, idx) {
    var o = opt.toLowerCase();
    if (o === 'size') sizeOptionIdx = idx;
    if (o === 'color') colorOptionIdx = idx;
  });
  if (sizeOptionIdx < 0) return;

  var sizeValues = [];
  (productData.variants || []).forEach(function (v) {
    var s = v['option' + (sizeOptionIdx + 1)];
    if (s && sizeValues.indexOf(s) < 0) sizeValues.push(s);
  });

  var state = { color: null, size: null };

  function getCurrentColor() {
    var el = document.getElementById('pdp-color-current');
    return el ? el.textContent : null;
  }

  function variantFor(color, size) {
    return (productData.variants || []).find(function (v) {
      var vColor = v['option' + (colorOptionIdx + 1)];
      var vSize = v['option' + (sizeOptionIdx + 1)];
      return (colorOptionIdx < 0 || vColor === color) && vSize === size;
    });
  }

  window.fetcApparelRefreshSizes = function (color) {
    state.color = color;
    sizesEl.querySelectorAll('.fetc-swatch').forEach(function (b) {
      var v = variantFor(color, b.dataset.size);
      var ok = v && v.available;
      b.classList.toggle('fetc-swatch--disabled', !ok);
      b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      if (!ok && b.classList.contains('fetc-swatch--selected')) {
        b.classList.remove('fetc-swatch--selected');
        b.setAttribute('aria-pressed', 'false');
        state.size = null;
        if (sizeCurrent) sizeCurrent.textContent = (window.__fetcT && window.__fetcT('products.apparel.select_prompt')) || 'Select';
      }
    });
    syncBuy();
  };

  function syncBuy() {
    var atcBtn = document.querySelector('.product-form__submit');
    if (!atcBtn) return;
    var v = state.size ? variantFor(state.color, state.size) : null;
    if (!state.size) {
      atcBtn.disabled = true;
    } else if (v && v.available) {
      atcBtn.disabled = false;
    } else {
      atcBtn.disabled = true;
    }
  }

  sizeValues.forEach(function (s) {
    var b = document.createElement('button');
    b.className = 'fetc-swatch';
    b.type = 'button';
    b.textContent = s;
    b.dataset.size = s;
    b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', function () {
      if (b.classList.contains('fetc-swatch--disabled')) return;
      state.size = s;
      if (sizeCurrent) sizeCurrent.textContent = s;
      sizesEl.querySelectorAll('.fetc-swatch').forEach(function (x) {
        x.classList.remove('fetc-swatch--selected');
        x.setAttribute('aria-pressed', 'false');
      });
      b.classList.add('fetc-swatch--selected');
      b.setAttribute('aria-pressed', 'true');
      var nativePicker = document.querySelector('.variant-picker [data-option-index="' + sizeOptionIdx + '"]');
      if (nativePicker) {
        nativePicker.value = s;
        nativePicker.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncBuy();
    });
    sizesEl.appendChild(b);
  });

  var initColor = getCurrentColor();
  if (initColor) window.fetcApparelRefreshSizes(initColor);
})();
/* END FETC CUSTOM */

/* === APPAREL A-5: Size guide modal open/close === */
/* FETC CUSTOM: Apparel — Size guide modal open/close (redesign-2026) */
(function () {
  var modal = document.getElementById('pdp-size-modal');
  var trigger = document.getElementById('pdp-size-guide-btn');
  if (!modal || !trigger) return;

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var closeBtn = modal.querySelector('.pdp-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    trigger.focus();
  }

  trigger.addEventListener('click', openModal);

  modal.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
/* ── BTS HERO: Ken-burns zoom on image load ──────────────────── */
(function () {
  var heroImg = document.getElementById('bts-hero-img');
  if (!heroImg) return;
  function addLoaded() { heroImg.classList.add('loaded'); }
  if (heroImg.complete) { addLoaded(); }
  else { heroImg.addEventListener('load', addLoaded); }
})();

/* ── BTS TOPIC FILTER: visual-only active toggle (Phase1) ───── */
(function () {
  var pills = document.querySelectorAll('.bts-topics .bts-topics__pill');
  if (!pills.length) return;
  pills.forEach(function (btn) {
    btn.addEventListener('click', function () {
      pills.forEach(function (b) { b.classList.remove('bts-topics__pill--active'); });
      btn.classList.add('bts-topics__pill--active');
    });
  });
  /* Phase2: URL 遷移型フィルタ（/blogs/behind-the-sip/tagged/{handle}）は別タスク */
})();
/* END FETC CUSTOM */
/* === ARTICLE-GUIDE: TOC active highlight === */
/* FETC CUSTOM: TOC IntersectionObserver for encyclopedia articles — Phase2-F AG-4-JS
   Scoped to body.template-suffix-fetc-encyclopedia only.
   Does NOT conflict with existing TOC generation inline script in fetc-main-article.liquid.
   Source: docs/redesign-2026/build-specs/article-guide.md §4 TOC JS
*/
(function () {
  if (!document.body.classList.contains('template-suffix-fetc-encyclopedia')) return;
  function initTOC() {
    var links = document.querySelectorAll('.fetc-toc__link');
    if (!links.length) return;
    var targets = [];
    links.forEach(function (l) {
      var id = l.getAttribute('href').replace('#', '');
      var el = document.getElementById(id);
      if (el) targets.push(el);
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('fetc-toc__link--active'); });
        var idx = targets.indexOf(e.target);
        if (idx !== -1) links[idx].classList.add('fetc-toc__link--active');
      });
    }, { rootMargin: '-20% 0px -60% 0px' });
    targets.forEach(function (t) { observer.observe(t); });
  }
  /* Mobile: collapse TOC before first paint */
  if (window.innerWidth <= 768) {
    var d = document.querySelector('.fetc-toc-details');
    if (d) d.removeAttribute('open');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTOC);
  } else {
    initTOC();
  }
})();
/* FETC CUSTOM: Mega Panel backdrop + Esc close (部品4) */
(function() {
  var MEGA_OPEN_CLASS = 'navigation__item--show-children';
  var MEGA_SELECTOR = '.navigation.navigation--main .navigation__item--with-mega-menu';

  /* バックドロップを body に1つだけ作成 */
  var backdrop = document.querySelector('.fetc-mega-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'fetc-mega-backdrop';
    document.body.appendChild(backdrop);
  }

  function isMegaOpen() {
    return document.querySelector(MEGA_SELECTOR + '.' + MEGA_OPEN_CLASS) !== null;
  }

  function syncBackdrop() {
    if (isMegaOpen()) {
      backdrop.classList.add('is-open');
    } else {
      backdrop.classList.remove('is-open');
    }
  }

  function closeAllMega() {
    document.querySelectorAll(MEGA_SELECTOR + '.' + MEGA_OPEN_CLASS).forEach(function(li) {
      li.dispatchEvent(new Event('mouseleave'));
    });
  }

  /* native class 変化を監視してバックドロップ同期 */
  var observer = new MutationObserver(syncBackdrop);
  var navMain = document.querySelector('.navigation.navigation--main');
  if (navMain) {
    observer.observe(navMain, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  /* バックドロップクリックで閉じる */
  backdrop.addEventListener('click', closeAllMega);

  /* Esc キーで閉じる */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeAllMega(); }
  });

  /* DOMContentLoaded 後に再チェック（CSR 対応） */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBackdrop);
  } else {
    syncBackdrop();
  }
})();
/* END FETC CUSTOM: Mega Panel backdrop */
/* END FETC CUSTOM */

/* {%- comment -%} FETC CUSTOM: Search Overlay hook {%- endcomment -%} */
// === 6. SEARCH OVERLAY: native main-search.js への hook ===
// native の CustomEvent 'main-search:open' / 'main-search:close' に hook するか、
// show-search-link クリックをキャッチして 50ms delay でフォーカスを与える
(function() {
  var searchEl = document.querySelector('.main-search');
  if (!searchEl) return;
  var input = searchEl.querySelector('.main-search__input, input[type="search"]');
  // open 検知: is-visible class が付いた時
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        if (searchEl.classList.contains('is-visible') || searchEl.classList.contains('main-search--open')) {
          searchEl.setAttribute('aria-hidden', 'false');
          if (input) { setTimeout(function() { input.focus(); }, 50); }
        } else {
          searchEl.setAttribute('aria-hidden', 'true');
        }
      }
    });
  });
  observer.observe(searchEl, { attributes: true });
  // ESC で閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && (searchEl.classList.contains('is-visible') || searchEl.classList.contains('main-search--open'))) {
      searchEl.classList.remove('is-visible', 'main-search--open');
    }
  });
})();
/* END FETC CUSTOM: Search Overlay hook */


/* ── FAQ ACCORDION ─────────────────────────────────────── */
/* FETC CUSTOM: fetc-accordion toggle — pg-faq.html §accordion JS */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.fetc-accordion__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panelId = btn.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);
        if (!panel) return;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.setAttribute('aria-hidden', expanded ? 'true' : 'false');
      });
    });
  });
})();
/* END FETC CUSTOM: FAQ Accordion */

/* FETC CUSTOM: Collection sort-dd — delegated so it survives FilterContainer AJAX toolbar refresh (redesign 2026-06-06).
   モバイルのフィルタ開閉は Symmetry FilterContainer の [data-toggle-filters] デリゲートが担当するため JS 不要。 */
(function() {
  'use strict';
  document.addEventListener('click', function(e) {
    // sort オプションクリック → 該当 URL へ遷移（フルリロード）
    var opt = e.target.closest('.sort-dd__opt[data-sort-url]');
    if (opt) {
      e.preventDefault();
      var url = opt.getAttribute('data-sort-url');
      if (url) { window.location.href = url; }
      return;
    }
    // sort トグルボタン → 開閉
    var btn = e.target.closest('#js-sort-btn');
    if (btn) {
      var list = document.getElementById('js-sort-list');
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (list) { list.style.display = expanded ? 'none' : 'block'; }
      return;
    }
    // それ以外をクリック → 閉じる
    var openBtn = document.getElementById('js-sort-btn');
    var openList = document.getElementById('js-sort-list');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); }
    if (openList) { openList.style.display = 'none'; }
  });
})();
/* END FETC CUSTOM: Collection sort-dd */

/* FETC CUSTOM: Collection filter group accordion — delegated（caret クリックで開閉・redesign 2026-06-06） */
(function() {
  'use strict';
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.fetc-filter__toggle');
    if (!btn) return;
    var group = btn.closest('.fetc-filter__group');
    if (!group) return;
    var collapsed = group.classList.toggle('is-collapsed');
    btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  });
})();
/* END FETC CUSTOM: Collection filter group accordion */

/* FETC CUSTOM: market-aware free-shipping bar — 変換市場は Shopify.currency.rate で % 計算（redesign 2026-06-06） */
(function() {
  'use strict';
  function fetcCsNiceRound(v) {
    if (v >= 10000) return Math.round(v / 1000) * 1000;
    if (v >= 1000) return Math.round(v / 100) * 100;
    if (v >= 100) return Math.round(v / 10) * 10;
    return Math.round(v / 5) * 5;
  }
  function fetcCsFmt(v, cur, loc) {
    try { return new Intl.NumberFormat(loc || undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(v); }
    catch (e) { return cur + ' ' + Math.round(v); }
  }
  function fetcUpdateFreeShip() {
    var rate = 1, active = 'JPY';
    if (window.Shopify && window.Shopify.currency) {
      rate = parseFloat(window.Shopify.currency.rate) || 1;
      active = window.Shopify.currency.active || 'JPY';
    }
    var loc = document.documentElement.getAttribute('lang') || 'en';
    document.querySelectorAll('[data-fs-bar]').forEach(function(bar) {
      var threshold = parseFloat(bar.getAttribute('data-fs-threshold')) || 0;
      var cart = parseFloat(bar.getAttribute('data-fs-cart')) || 0;
      var textEl = bar.querySelector('[data-fs-text]');
      if (!textEl || threshold <= 0) return;
      var thresholdLocal = threshold * rate;
      var pct = thresholdLocal > 0 ? Math.round(cart / thresholdLocal * 100) : 0;
      if (pct < 0) { pct = 0; }
      if (pct >= 100) {
        textEl.textContent = bar.getAttribute('data-fs-met') || 'Free shipping unlocked';
      } else {
        var remainTmpl = bar.getAttribute('data-fs-remain') || '';
        if (remainTmpl && remainTmpl.indexOf('__AMT__') !== -1) {
          var remainMajor = (thresholdLocal - cart) / 100;
          textEl.textContent = remainTmpl.replace('__AMT__', fetcCsFmt(fetcCsNiceRound(remainMajor), active, loc));
        } else {
          var tmpl = bar.getAttribute('data-fs-pct') || '{pct}% to free shipping';
          textEl.textContent = tmpl.replace('{pct}', 100 - pct);
        }
      }
      /* FETC CUSTOM CR-22: progress bar fill（Tai 2026-06-11） */
      var fillEl = bar.querySelector('[data-fs-fill]');
      if (fillEl) { fillEl.style.width = Math.min(Math.max(pct, 0), 100) + '%'; }
    });
  }
  document.addEventListener('DOMContentLoaded', fetcUpdateFreeShip);
  document.addEventListener('dispatch:cart-drawer:refresh', function() { setTimeout(fetcUpdateFreeShip, 150); });
  document.addEventListener('dispatch:cart-drawer:open', function() { setTimeout(fetcUpdateFreeShip, 150); });
})();
/* END FETC CUSTOM: market-aware free-shipping bar */

/* === APPAREL A-6: ATC initial state + button text sync === */
/* FETC CUSTOM: Apparel ATC — initial 'Select a size' + price-appended text on selection (redesign-2026) */
(function () {
  var initialized = false;
  var attempts = 0;

  function getAtcButton() {
    return document.querySelector('.product-form__submit, .add-to-cart[name="add"]');
  }

  function initApparelAtcSync() {
    if (initialized) return;

    var sizeBlock = document.getElementById('pdp-size-block');
    if (!sizeBlock) return;

    var productData = window.__fetcProductData;
    if (!productData) {
      attempts += 1;
      if (attempts < 20) {
        window.setTimeout(initApparelAtcSync, 50);
      }
      return;
    }

    initialized = true;

    function getPrice(variantId) {
      if (!variantId) return null;
      var v = (productData.variants || []).find(function (x) { return x.id === variantId; });
      return v ? v.price : null;
    }

    function formatMoney(cents) {
      if (!cents && cents !== 0) return '';
      var fmt = window.__fetcMoneyFormat || '';
      var dec = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var noDec = Math.round(cents / 100).toLocaleString('en-US');
      if (fmt.indexOf('{{') !== -1) {
        return fmt
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dec)
          .replace(/\{\{\s*amount\s*\}\}/g, dec);
      }
      return '¥' + noDec;
    }

    function getCurrentVariantId() {
      var inp = document.querySelector('.js-product-form input[name="id"]');
      return inp ? parseInt(inp.value, 10) : null;
    }

    function updateAtcBtn() {
      var atcBtn = getAtcButton();
      if (!atcBtn) return;
      var sizesEl = document.getElementById('pdp-sizes');
      var selected = sizesEl ? sizesEl.querySelector('.fetc-swatch--selected') : null;
      if (!selected) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Select a size';
      } else {
        var vid = getCurrentVariantId();
        var price = getPrice(vid);
        var priceStr = price !== null ? (' — ' + formatMoney(price)) : '';
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart' + priceStr;
      }
    }

    updateAtcBtn();

    var sizesEl = document.getElementById('pdp-sizes');
    if (sizesEl) {
      sizesEl.addEventListener('click', function () {
        window.setTimeout(updateAtcBtn, 50);
      });

      if (window.MutationObserver) {
        var observer = new MutationObserver(function () {
          window.setTimeout(updateAtcBtn, 0);
        });
        observer.observe(sizesEl, {
          attributes: true,
          attributeFilter: ['class', 'aria-pressed'],
          childList: true,
          subtree: true
        });
      }
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.variant-picker')) {
        window.setTimeout(updateAtcBtn, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApparelAtcSync);
  } else {
    initApparelAtcSync();
  }
})();
/* FETC CUSTOM: 言語ドロップダウン開閉（locale-dropdown-wrap / locale-btn / locale-listbox）。
   util/footer は fixed 位置をボタンに合わせる。mobile はインライン。 */
window.toggleLocaleDropdown = function(id) {
  var btnEl = document.getElementById(id + '-btn');
  var listbox = document.getElementById(id + '-listbox');
  if (!listbox) { return; }
  var isOpen = listbox.classList.contains('is-open');
  document.querySelectorAll('.locale-listbox.is-open').forEach(function(el) { el.classList.remove('is-open'); });
  document.querySelectorAll('[aria-haspopup="listbox"][aria-expanded="true"]').forEach(function(el) { el.setAttribute('aria-expanded', 'false'); });
  if (!isOpen) {
    var wrapEl = btnEl ? btnEl.closest('.locale-dropdown-wrap') : null;
    if (wrapEl && !wrapEl.classList.contains('mobile-locale-dropdown-wrap') && !wrapEl.classList.contains('footer-locale-dropdown-wrap') && btnEl) {
      var rect = btnEl.getBoundingClientRect();
      listbox.style.position = 'fixed';
      listbox.style.top = (rect.bottom + 4) + 'px';
      listbox.style.left = 'auto';
      listbox.style.right = (window.innerWidth - rect.right) + 'px';
    }
    listbox.classList.add('is-open');
    if (btnEl) { btnEl.setAttribute('aria-expanded', 'true'); }
  }
};
document.addEventListener('click', function(e) {
  /* CR-12: mobile wrap は locale-dropdown-wrap を持たない（mock 同構造化）— 含めないと開いた同一クリックのバブルで即閉じる */
  if (e.target && typeof e.target.closest === 'function' && !e.target.closest('.locale-dropdown-wrap, .mobile-locale-dropdown-wrap')) {
    document.querySelectorAll('.locale-listbox.is-open').forEach(function(el) { el.classList.remove('is-open'); });
    document.querySelectorAll('[aria-haspopup="listbox"][aria-expanded="true"]').forEach(function(el) { el.setAttribute('aria-expanded', 'false'); });
  }
});
/* END FETC CUSTOM */
/* FETC CUSTOM: card quick-add delegation (H3) */
(function() {
  function getFormRoot(form) {
    var node = form;
    while (node && node !== document) {
      if (node.tagName && node.tagName.toLowerCase() === 'product-form') {
        return node;
      }
      node = node.parentNode;
    }
    return form;
  }

  function getSubmitButton(form, root) {
    return form.querySelector('[name="add"]') || (root && root.querySelector ? root.querySelector('[name="add"]') : null);
  }

  function setErrorMsgState(root, error) {
    var errorMsg = root && root.querySelector ? root.querySelector('.js-form-error') : null;
    var errorArray;
    var i;

    if (!errorMsg) return;

    errorMsg.hidden = !error;
    if (!error) return;

    errorMsg.innerHTML = '';
    errorArray = Array.isArray(error) ? error : [error];
    for (i = 0; i < errorArray.length; i += 1) {
      if (i > 0) errorMsg.insertAdjacentHTML('beforeend', '<br>');
      errorMsg.insertAdjacentText('beforeend', errorArray[i]);
    }
  }

  function dispatchFrom(root, eventName, detail) {
    root.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: detail
    }));
  }

  function nativeSubmit(form) {
    if (window.HTMLFormElement && HTMLFormElement.prototype.submit) {
      HTMLFormElement.prototype.submit.call(form);
    } else {
      form.submit();
    }
  }

  function getSectionsToUpdate() {
    var selectors = ['page-header', 'cart-drawer'];
    var sections = [];
    var i;
    var el;

    for (i = 0; i < selectors.length; i += 1) {
      el = document.querySelector(selectors[i]);
      if (el) sections.push(el);
    }

    return sections;
  }

  function getSectionIds(sectionsToUpdate) {
    var sectionIds = [];
    var i;

    for (i = 0; i < sectionsToUpdate.length; i += 1) {
      sectionIds.push(sectionsToUpdate[i].dataset.sectionId);
    }

    return sectionIds;
  }

  function getDataError(data) {
    var error = typeof data.description === 'string' ? data.description : data.message;
    var errors;
    var key;
    var item;

    if (data.errors && typeof data.errors === 'object') {
      errors = [];
      for (key in data.errors) {
        if (Object.prototype.hasOwnProperty.call(data.errors, key)) {
          item = data.errors[key];
          errors.push(item && typeof item.join === 'function' ? item.join(', ') : item);
        }
      }
      error = errors;
    }

    return error;
  }

  function restoreSubmitButton(submitBtn) {
    if (!submitBtn) return;
    submitBtn.classList.remove('is-loading');
    submitBtn.classList.remove('is-success');
    submitBtn.removeAttribute('aria-disabled');
  }

  function handleError(form, root, submitBtn, error) {
    console.error(error);
    dispatchFrom(root, 'on:cart:error', {
      error: error && error.message ? error.message : error
    });
    dispatchFrom(root, 'on:cart:change');
    restoreSubmitButton(submitBtn);
    nativeSubmit(form);
  }

  function handleSuccess(root, submitBtn, response, data, sectionsToUpdate) {
    var cartForm;
    var i;
    var notification;
    var notificationContainer;

    if (data.status) setErrorMsgState(root, getDataError(data));
    if (!response.ok) throw new Error(response.status);

    if (document.querySelector('.template-cart')) {
      cartForm = document.querySelector('cart-form');
      if (cartForm && cartForm.enableAjaxUpdate) {
        cartForm.refresh();
      }
    } else if (theme.settings.afterAddToCart === 'page') {
      setTimeout(function() {
        window.location.href = theme.routes.cart;
      }, 300);
    } else {
      if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
        for (i = 0; i < sectionsToUpdate.length; i += 1) {
          sectionsToUpdate[i].updateFromCartChange(data.sections[sectionsToUpdate[i].dataset.sectionId]);
        }
      } else {
        dispatchFrom(root, 'on:cart:change');
      }

      if (theme.settings.afterAddToCart === 'notification') {
        notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
        notification.dataset.productTitle = data.product_title;
        notificationContainer = document.querySelector('.pageheader--sticky');
        if (!notificationContainer) {
          notificationContainer = document.querySelector('body');
        }
        notificationContainer.appendChild(notification);
      } else if (theme.settings.afterAddToCart === 'drawer') {
        document.querySelector('.js-cart-drawer').open(submitBtn);
      }
    }

    dispatchFrom(root, 'on:cart:add', {
      variantId: data.variant_id
    });

    if (submitBtn) {
      submitBtn.classList.add('is-success');
      submitBtn.removeAttribute('aria-disabled');
      setTimeout(function() {
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.remove('is-success');
      }, 2000);
    }
  }

  document.addEventListener('submit', function(evt) {
    var form = evt.target;
    var root;
    var submitBtn;
    var formData;
    var sectionsToUpdate;
    var sectionIds;
    var fetchRequestOpts;

    if (!form || !form.classList || !form.classList.contains('fetc-card-atc-form')) return;
    if (!window.theme || !theme.settings || theme.settings.afterAddToCart === 'no-js') return;

    evt.preventDefault();
    root = getFormRoot(form);
    submitBtn = getSubmitButton(form, root);

    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

    setErrorMsgState(root);

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('is-loading');
    }

    formData = new FormData(form);
    sectionsToUpdate = getSectionsToUpdate();
    sectionIds = getSectionIds(sectionsToUpdate);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    fetchRequestOpts = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      fetch(theme.routes.cartAdd, fetchRequestOpts)
        .then(function(response) {
          return response.json().then(function(data) {
            return {
              response: response,
              data: data
            };
          });
        })
        .then(function(result) {
          handleSuccess(root, submitBtn, result.response, result.data, sectionsToUpdate);
        })
        .catch(function(error) {
          handleError(form, root, submitBtn, error);
        });
    } catch (error) {
      handleError(form, root, submitBtn, error);
    }
  }, true);
})();
/* END FETC CUSTOM */

/* FETC CUSTOM CR-26: mobile(≤1000px) の filter groups は初期 collapsed（mock renderFilters と同挙動・2026-06-11） */
(function() {
  'use strict';
  function fetcCollapseMobileFilters() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 1000px)').matches) { return; }
    document.querySelectorAll('.col-sidebar .fetc-filter__group').forEach(function(g) {
      g.classList.add('is-collapsed');
      var btn = g.querySelector('.fetc-filter__toggle');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetcCollapseMobileFilters);
  } else {
    fetcCollapseMobileFilters();
  }
})();
/* END FETC CUSTOM CR-26 */

/* FETC CUSTOM CR-25: rec 画像を常に正方形（カード実高に幅を同期）。
   CSS の aspect-ratio は flex item の幅 transfer が Chrome で効かない（2026-06-11 実験）ため JS 同期 */
(function() {
  'use strict';
  var fetcRecRo = null;
  function fetcApplySquare(card) {
    var img = card.querySelector('.cart-rec__img');
    if (!img) { return; }
    var h = Math.round(card.getBoundingClientRect().height);
    /* width と height を両方固定 — width のみだと img の intrinsic 比率で高さが伸び
       ResizeObserver と無限拡大ループになる（card_h 6085px 暴走の実測 2026-06-11）。
       height を definite にすれば card 高 = max(img, body) で収束。h<400 は安全弁 */
    if (h > 2 && h < 400) {
      img.style.width = (h - 2) + 'px';
      img.style.height = (h - 2) + 'px';
    }
  }
  function fetcSquareRecImgs() {
    /* ResizeObserver: 画像 lazy load / フォントでカード高が後から変わっても追従（初回固定値は stale 化した実測 2026-06-11） */
    if (!fetcRecRo && window.ResizeObserver) {
      fetcRecRo = new ResizeObserver(function(entries) {
        entries.forEach(function(e) { fetcApplySquare(e.target); });
      });
    }
    document.querySelectorAll('.cart-rec__card').forEach(function(card) {
      fetcApplySquare(card);
      if (fetcRecRo) { fetcRecRo.observe(card); }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetcSquareRecImgs);
  } else {
    fetcSquareRecImgs();
  }
  document.addEventListener('dispatch:cart-drawer:open', function() { setTimeout(fetcSquareRecImgs, 200); });
  document.addEventListener('dispatch:cart-drawer:refresh', function() { setTimeout(fetcSquareRecImgs, 250); });
})();
/* END FETC CUSTOM CR-25 */

/* FETC CUSTOM CR-62 R10 fix2: guides tag-filter 親グループ展開 — document 委譲（section の innerHTML 再レンダ・inline script 非実行に耐える。Tai 2026-06-11） */
(function() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tag-filter__pill--has-sub');
    if (!btn) return;
    e.preventDefault();
    var sub = document.querySelector('.tag-filter__sub');
    if (!sub) return;
    var wasOpen = btn.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('.tag-filter__pill--has-sub').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    sub.querySelectorAll('.tag-filter__children').forEach(function (g) { g.classList.remove('is-open'); });
    sub.hidden = true;
    if (!wasOpen) {
      var grp = sub.querySelector('.tag-filter__children[data-group="' + btn.getAttribute('data-sub') + '"]');
      if (grp) {
        btn.setAttribute('aria-expanded', 'true');
        grp.classList.add('is-open');
        sub.hidden = false;
      }
    }
  });

  /* ?sub=history|teaware で初期展開（R8 由来の機能を委譲版に移植 — fix3） */
  function fetcTagFilterInitFromQuery() {
    var want = (new URLSearchParams(location.search)).get('sub');
    if (!want) return;
    var btn = document.querySelector('.tag-filter__pill--has-sub[data-sub="' + want + '"]');
    var sub = document.querySelector('.tag-filter__sub');
    if (!btn || !sub) return;
    var grp = sub.querySelector('.tag-filter__children[data-group="' + want + '"]');
    if (grp) {
      btn.setAttribute('aria-expanded', 'true');
      grp.classList.add('is-open');
      sub.hidden = false;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetcTagFilterInitFromQuery);
  } else {
    fetcTagFilterInitFromQuery();
  }
})();
/* END FETC CUSTOM CR-62 R10 fix2 */

/* FETC CUSTOM CR-73/77 R11: TOC・FAQ カテゴリのアンカーを scroll-margin-top 尊重でスクロール
   （capture で native internalLinksSmoothScroll の固定オフセット計算を抑止。Tai 2026-06-12） */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.fetc-toc__link, .faq-cat-nav__link');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var id = href.split('#')[1];
    if (!id) return;
    var tgt = document.getElementById(id);
    if (!tgt) return;
    e.preventDefault();
    e.stopPropagation();
    tgt.scrollIntoView({ behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }, true);
})();
/* END FETC CUSTOM CR-73/77 R11 */

/* FETC CUSTOM CR-79 R12: contact Subject custom dropdown — collection sort-dd と同一挙動。
   選択値は hidden input contact[subject] に格納。未選択 submit は阻止して dd を開く（Tai 2026-06-12） */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#fetc-subject-btn');
    var dd = document.getElementById('fetc-subject-dd');
    if (!dd) return;
    var list = document.getElementById('fetc-subject-list');
    var ddBtn = document.getElementById('fetc-subject-btn');
    if (btn) {
      e.stopPropagation();
      var open = list.classList.toggle('is-open');
      ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var opt = e.target.closest('#fetc-subject-list .sort-dd__opt');
    if (opt) {
      list.querySelectorAll('.sort-dd__opt').forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-selected', 'false');
      });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-selected', 'true');
      var current = document.getElementById('fetc-subject-current');
      if (current) {
        current.textContent = opt.textContent.trim();
        current.classList.remove('sort-dd__placeholder');
      }
      var hidden = document.getElementById('fetc-contact-subject');
      if (hidden) hidden.value = opt.getAttribute('data-value') || opt.textContent.trim();
      list.classList.remove('is-open');
      ddBtn.setAttribute('aria-expanded', 'false');
      return;
    }
    if (list && list.classList.contains('is-open')) {
      list.classList.remove('is-open');
      ddBtn.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector || !form.querySelector('#fetc-subject-dd')) return;
    var hidden = document.getElementById('fetc-contact-subject');
    if (hidden && !hidden.value) {
      e.preventDefault();
      var list = document.getElementById('fetc-subject-list');
      var ddBtn = document.getElementById('fetc-subject-btn');
      if (list) list.classList.add('is-open');
      if (ddBtn) {
        ddBtn.setAttribute('aria-expanded', 'true');
        ddBtn.focus();
      }
    }
  }, true);
})();
/* END FETC CUSTOM */

/* FETC CUSTOM: col-toolbar 実高 → --fetc-col-tb-h（mobile sticky filter panel 用、2026-06-12）
   AJAX filtering は .col-toolbar の中身だけ差し替えるため要素参照は生存する。 */
(function () {
  var toolbar = document.querySelector('.col-toolbar');
  if (!toolbar || !('ResizeObserver' in window)) return;
  var setH = function () {
    document.documentElement.style.setProperty('--fetc-col-tb-h', toolbar.offsetHeight + 'px');
  };
  new ResizeObserver(setH).observe(toolbar);
  setH();
})();
/* END FETC CUSTOM */

/* FETC CUSTOM: util-bar market-aware free-shipping — convert JPY threshold to the buyer's local currency for localCurrencies markets (free-shipping-threshold-2026-06) */
(function () {
  'use strict';
  function fetcUbNiceRound(v) {
    if (v >= 10000) return Math.round(v / 1000) * 1000;
    if (v >= 1000) return Math.round(v / 100) * 100;
    if (v >= 100) return Math.round(v / 10) * 10;
    return Math.round(v / 5) * 5;
  }
  function fetcUbFmt(v, cur, loc) {
    try { return new Intl.NumberFormat(loc || undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(v); }
    catch (e) { return cur + ' ' + Math.round(v); }
  }
  function fetcUtilBarConvert() {
    var el = document.getElementById('util-bar-msg');
    if (!el || el.getAttribute('data-ub-fs') !== '1') return;
    var thr = parseFloat(el.getAttribute('data-ub-threshold')) || 0;
    var approx = el.getAttribute('data-ub-approx') || '';
    if (thr <= 0 || approx.indexOf('__AMT__') === -1) return;
    var c = (window.Shopify && window.Shopify.currency) ? window.Shopify.currency : null;
    if (!c) return;
    var active = c.active || 'JPY';
    var rate = parseFloat(c.rate) || 1;
    if (active === 'JPY' || rate === 1) return;
    var conv = fetcUbNiceRound(thr / 100 * rate);
    var loc = document.documentElement.getAttribute('lang') || 'en';
    el.textContent = approx.replace('__AMT__', fetcUbFmt(conv, active, loc));
  }
  document.addEventListener('DOMContentLoaded', fetcUtilBarConvert);
})();
/* END FETC CUSTOM: util-bar market-aware free-shipping */
